import React, { Component } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class ErrorDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open:true
    }
  }

  handleClickOpen = () => {
    this.setState({
      open:true,
    })
  };

  handleClose = () => {
    this.setState({
      open:false,
    })
    this.props.resetErrorState()
  };
  render() {
    const open = this.state.open;
    return (
      <div >
        <Dialog
          open={open}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <h2>Oops something went wrong!!</h2>
              <h4>Whatever happened, it was probably our fault. Please try again later.</h4>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary" autoFocus>
              Ok
          </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
export default ErrorDialog;